import { GameCardData } from '@/features/games/internal/types/game-card-data';
import { useAppStore } from '@/features/shared/app-store';

export const setContinueToPlayGameCard = (card: GameCardData) =>
  useAppStore.getState().setContinueToPlayGameCard(card);
